import { useNavigate } from 'react-router';
import { paths } from '@/routes-utils/paths.ts';
import { NudgeCard } from '../nudge-card.tsx';
import StreamDeckNudgeImg from './stream-deck-nudge.png';

export const StreamDeckNudge = () => {
  const navigate = useNavigate();
  return (
    <NudgeCard
      title="See all your streams on one customized page"
      description="All your feeds. One space."
      image={{ src: StreamDeckNudgeImg, alt: 'NewsDeck nudge' }}
      buttonText="Try NewsDeck"
      onClick={() => {
        window.mixpanel?.track('Stream Deck Nudge Clicked');
        navigate(`${paths.newsDeck}?from=nudge`);
      }}
    />
  );
};
